import { attr, html, MapSignal, on } from '@tempots/dom'
import type { WizardState } from '../wizard-state'

export interface ChoosePathOptions {
  /** Closes the wizard and drops the user into the editor as-is. */
  onSkipToEditor: () => void
}

export function ChoosePathStep(state: WizardState, options: ChoosePathOptions) {
  return html.div(
    MapSignal(state.importError, err =>
      err
        ? html.div(
            attr.class('wiz-error'),
            `${err} You can try a different document, or build your header from your info instead.`
          )
        : html.span()
    ),
    html.div(
      attr.class('wiz-tiles'),
      html.button(
        attr.type('button'),
        attr.class('wiz-tile'),
        on.click(() => {
          state.path.set('import')
          state.importError.set(null)
          state.step.set('upload')
        }),
        html.div(attr.class('wiz-tile-icon'), '📄'),
        html.div(
          attr.class('wiz-tile-title'),
          'Copy my existing header',
          html.span(attr.class('wiz-tile-badge'), 'RECOMMENDED')
        ),
        html.div(
          attr.class('wiz-tile-body'),
          'Upload a resume you’ve already branded (Word or PDF). We rebuild your header here — and make the contact details update automatically for every recruiter.'
        )
      ),
      html.button(
        attr.type('button'),
        attr.class('wiz-tile'),
        on.click(() => {
          state.path.set('build')
          state.step.set('shape')
        }),
        html.div(attr.class('wiz-tile-icon'), '🧱'),
        html.div(attr.class('wiz-tile-title'), 'Build it from my info'),
        html.div(
          attr.class('wiz-tile-body'),
          'Pick a layout and we’ll fill it in with your agency details and logo. Ready in under a minute.'
        )
      ),
      html.button(
        attr.type('button'),
        attr.class('wiz-tile'),
        on.click(options.onSkipToEditor),
        html.div(attr.class('wiz-tile-icon'), '🎨'),
        html.div(attr.class('wiz-tile-title'), 'I’ll build it from scratch'),
        html.div(
          attr.class('wiz-tile-body'),
          'Skip the wizard and go straight to the design editor — full control over every text block, box, image, and color.'
        )
      )
    )
  )
}
